import * as React from 'react';
import * as ReactDOM from 'react-dom';

import KendoBaseComponent, { KendoWidgetProps } from '@progress/kendo-base-component-react-wrapper';

export interface ButtonGroupProps extends KendoWidgetProps, kendo.ui.ButtonGroupOptions {
    children?: React.ReactNode;
}

export default class ButtonGroup extends KendoBaseComponent<ButtonGroupProps, {}> {
    componentDidMount(): void {
        const domNode = this.domNode;
        const { children, widgetRef, ...props } = this.props;

        if (domNode) {
            this.widgetInstance =
                new kendo.ui.ButtonGroup(domNode as Element, (props as kendo.ui.ButtonGroupOptions));
            super.componentDidMount();
        }
    }

    render(): any {
        if (this.didMount) {
            const { children, widgetRef, ...props } = this.props;

            this.widgetInstance.setOptions(props);
        }
        
        return (
            <ul ref={this.elementRef}>
                {this.props.children}
            </ul>
        );
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-buttons-react-wrapper/src/button-group/index.tsx